import React from 'react';
import ProductPage from '../components/product-page';

export default function BcpTheaterPage() {
  return (
    <ProductPage
      title="Breaker Control Panel with DMX"
      className="smart-power-theater"
      demoLink="http://benjaminelectric.com/bci"
      images={[
        {
          src: 'bcp.png',
          alt: 'Black Panelboard with door open',
        },
        {
          src: 'bcp-pmi.png',
          alt: 'Sample image of web interface for smart control',
        },
      ]}
      sections={[
        {
          title: 'Description',
          id: 'description',
          content: (
            <>
              A panelboard offering remote on/off control of the branch circuits
              using standard DMX-512, DMX-RDM, or ACN connectivity.
            </>
          ),
        },
        {
          title: 'Features',
          id: 'features',
          content: (
            <ul>
              <li>
                Remotely operate Eaton circuit breakers via DMX or ACN
                protocols.
              </li>
              <li>
                Built-in delay for sequential breaker operation reduces in-rush
                current impacts from LED driver loads.
              </li>
              <li>
                All circuit capacities utilize industry standard 20" width
                enclosure.
              </li>
              <li>
                Configurations are built to order and arrive from our factory
                fully assembled and tested.
              </li>
              <li>Metering available on Mains and Branch Circuits.</li>
              <li>
                Industry Standard communication protocols are supported for
                integration with Building Management Systems or use the built in
                scheduler to control circuits.
              </li>
            </ul>
          ),
        },
        {
          title: 'Specifications',
          id: 'specifications',
          content: (
            <>
              <table>
                <tbody>
                  <tr>
                    <th>Voltage Ratings</th>
                    <td>120/240V 1Ø 3W</td>
                    <td>208Y/120V 3Ø 4W</td>
                    <td>480Y/277V 3Ø 4W</td>
                  </tr>
                </tbody>
              </table>
              <table id="aic_ratings">
                <tbody>
                  <tr>
                    <th rowSpan="2">AIC Ratings</th>
                    <td className="left-align">
                      65kAIC@240V Fully Rated to 100kAIC Series Rated
                    </td>
                  </tr>
                  <tr>
                    <td className="left-align">
                      14kAIC@480Y/277V Fully Rated to 65kAIC Series Rated
                    </td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>

              <table id="breaker_options">
                <tbody>
                  <tr>
                    <th rowSpan="3">Branch Circuit Breaker Options</th>
                    <td>1 Pole</td>
                    <td className="left-align">
                      Ratings: 15A, 20A, 30A Controlled, 15A to 100A
                      non-controlled
                    </td>
                  </tr>
                  <tr>
                    <td>2 Pole</td>
                    <td className="left-align">
                      Ratings: 15A, 20A, 30A Controlled, 15A to 100A
                      non-controlled
                    </td>
                  </tr>
                  <tr>
                    <td>3 Pole</td>
                    <td className="left-align">
                      Ratings: 15A to 100A non-controlled
                    </td>
                  </tr>
                </tbody>
              </table>

              <table id="main_options">
                <tbody>
                  <tr>
                    <th rowSpan="2">Mains Configurations</th>
                    <td>Lugs</td>
                    <td className="left-align">
                      Ratings: 100A, 225A, 400A, and 600A Rated
                    </td>
                  </tr>
                  <tr>
                    <td>Breaker</td>
                    <td className="left-align">
                      Ratings: 100A, 225A, 400A, and 600A Rated
                    </td>
                  </tr>
                </tbody>
              </table>

              <table id="breaker_options">
                <tbody>
                  <tr>
                    <th rowSpan="6">Power Measurement</th>
                    <td>Mains Current Accuracy</td>
                    <td className="left-align">
                      1% of reading from 1% to 100% of nominal rated current
                    </td>
                  </tr>
                  <tr>
                    <td>Mains Voltage Accuracy</td>
                    <td className="left-align">
                      0.5% of reading from 90 to 600 VAC Line to Neutral
                    </td>
                  </tr>
                  <tr>
                    <td>Mains Power Data</td>
                    <td className="left-align">
                      Voltage, Current, Watts, PF, VA, VAR, HZ, WHrs, VAHrs,
                      VARHrs
                    </td>
                  </tr>
                  <tr>
                    <td>Branch Current Accuracy</td>
                    <td className="left-align">
                      1% of reading from 0.15 Amps to 100 Amps
                    </td>
                  </tr>
                  <tr>
                    <td>Branch Circuit Data</td>
                    <td className="left-align">
                      Current, Watts, PF, VA, VAR, WattHrs, VAHrs, VARHrs
                    </td>
                  </tr>
                  <tr>
                    <td>Data Update Rate</td>
                    <td className="left-align">
                      1 second for all real-time values
                    </td>
                  </tr>
                </tbody>
              </table>

              <table id="communications">
                <tbody>
                  <tr>
                    <th>Communications</th>
                    <td className="left-align">
                      DMX-512, DMX-RDM, ACN, Modbus 485, Modbus TCP/IP,
                      BACnet/IP
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ),
        },
        {
          title: 'Downloads',
          id: 'downloads',
          content: (
            <ul style={{ listStyle: 'none' }}>
              <li>
                <a href="/downloads/bcp-product-sheet.pdf">Product Sheet</a>
              </li>
              <li>
                <a href="/downloads/bcp-configuration-guide.pdf">
                  Configuration Guide
                </a>
              </li>
            </ul>
          ),
        },
      ]}
    />
  );
}
